import { getData, putData } from '../plugins/ApiCalls'

export function fetchEmailVerification(data) {
  return getData('user-settings', data, { emulateJSON: true })
}

export function updateEmailVerification(data) {
  return putData('user-settings' + '/emailverification', data, { emulateJSON: true })
}
